// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {
    /* Greif Custom Code - Start */
    1: "0px 0px 1px 0px rgba(48, 49, 51, 0.05), 0px 2px 4px 0px rgba(48, 49, 51, 0.1)",
    2: "0px 10px 15px 0px rgba(93, 93, 93, 0.1)",
    3: "0px 0px 1px 0px rgba(48, 49, 51, 0.05), 0px 16px 24px 0px rgba(48, 49, 51, 0.1)",
    /* Greif Custom Code - End */
};

export default shadows;
